import { FC, useCallback } from 'react';
import { Button, Typography } from '@mui/material';
import { setIrrelevant } from '../actions/applications-actions';
import ModalDialog from '../../common/components/ModalDialog';
import { useSnapshot } from 'valtio';
import ApplicationsStore from '../stores/applications-store';
import ExclusionComment from '../../elements/ExclusionComment/ExclusionComment';
import { setExclusionComment } from '../stores/applications-store-actions';

const IrrelevanceConfirmationContainer: FC<
  React.PropsWithChildren<IrrelevanceConfirmationContainerProps>
> = ({ open, setOpen }) => {
  const { selectedCount, selectedApp } = useSnapshot(ApplicationsStore);
  const onClose = useCallback(() => setOpen(false), [setOpen]);
  const onSubmit = useCallback(() => {
    setIrrelevant();
    onClose();
  }, [onClose]);

  return (
    <ModalDialog
      onClose={onClose}
      modalHeader='Make Irrelevant'
      open={open}
      modalFooter={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onSubmit}>Make Irrelevant</Button>
        </>
      }>
      <Typography variant='body1' color='text.primary'>
        {selectedCount > 1
          ? `The selected applications will be marked as irrelevant. This will remove all current issues from these applications. Future scans will also ignore these applications completely. These applications will no longer appear on the Application Screen or Dashboard.`
          : `The selected application will be marked as irrelevant. This will remove all current issues from this application. Future scans will also ignore this application completely. The application will no longer appear on the Application Screen or Dashboard. `}
        <br />
        <br /> Note: This action can be undone in the “Irrelevant App Screen”.
      </Typography>
      <ExclusionComment
        excludeComment={selectedApp?.exclusionComment}
        setExcludeComment={setExclusionComment}
        message='Comment for this app:'
      />
    </ModalDialog>
  );
};

export interface IrrelevanceConfirmationContainerProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

export default IrrelevanceConfirmationContainer;
